import React from "react";
import {TextField} from "@material-ui/core";
import "./index.scss";
import {OutlinedTextFieldProps} from "@material-ui/core/TextField/TextField";

interface Props extends Partial<Omit<OutlinedTextFieldProps, 'onChange'>> {
    name?: string;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    hidden?: boolean;
    validationError?: string;
    handleChange?: (value: string) => void;
    type: any;
    listenerDependency?: any
    onChange?: (value: string) => void;
    toUpperCase?: boolean;
    noSpace?: boolean;
}

export const InputText = (props: Props) => {
    const {
        name,
        value,
        placeholder,
        label,
        disabled,
        hidden,
        error,
        validationError,
        onChange,
        type,
        toUpperCase,
        noSpace,
        ...rest
    } = props;

    const handleChange = (event) => {
        let val = event.target.value;
        if (noSpace) val = val.replace(/\s/g, '');
        if (toUpperCase) val = val.toUpperCase();

        if (type === 'NUMBER') val = val.replace(/[^0-9]/g, '');

        if (onChange) onChange(val);
    };

    return (
        <div className={'input-text'}>
            <TextField
                autoComplete="off"
                inputProps={{autocomplete: 'new-password',
                    form: {
                        autocomplete: 'off',
                    },
                    ...(type === 'NUMBER' ? { inputMode: 'numeric', pattern: '[0-9]*' } : {}),
                }}
                onChange={handleChange}
                type={type === 'NUMBER' ? 'text' : type} // to prevent Ios and Safari letters bug
                id={name}
                error={error}
                fullWidth={true}
                InputLabelProps={{
                    style: {
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        width: '92%'
                    } }}
                disabled={disabled}
                hidden={hidden}
                helperText={error && validationError}
                value={value || ''}
                variant={"outlined"}
                label={label}
                placeholder={placeholder}
                {...rest}
            />
        </div>
    )
};
